module.exports = __webpack_public_path__ + "static/media/Photo.9b8b992e.png";